import $ from 'jquery';
$(function () {
  $('.home-carousel').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
  });

  $('.v-rev-carousel').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
  });

  $('.hexagon-carousel').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 12000,
    infinite: true,
    speed: 500,
    fade: false,
    cssEase: 'linear',
  });

  $('.products-carousel').slick({
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.product-left'),
    nextArrow: $('.product-right'),
    responsive: [{
        breakpoint: 1400,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: "unslick"
      }
    ]
  });

  $('.article-carousel').slick({

    responsive: [{
        breakpoint: 767,
        settings: {
          dots: false,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 7000,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 99999,
        settings: 'unslick'
      }
    ]

  });

  $('.mainSwiper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoplay: true,
    asNavFor: '.thumbSwiper'
  });
  $('.thumbSwiper').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    asNavFor: '.mainSwiper',
    dots: false,
    centerMode: true,
    centerPadding: '0px',
    focusOnSelect: true
  });
      
});
		